module.exports = __webpack_public_path__ + "static/media/IMG-13.7e8137d4.jpg";